import React, { Component, Fragment } from 'react';
import { render } from 'react-dom';
import { asyncComponent } from 'react-async-component';
import Main from './Main.jsx';
import Project from './Project.jsx';
import './css/app.css';

/** We are importing our index.php my app Vairaible */

/* globals __webpack_public_path__ */
//__webpack_public_path__ = `${window.STATIC_URL}/app/assets/bundle/`;
__webpack_public_path__ = `${peterfuckingpath}`;

// import project from 'project';

class QuantrDocs extends Component {
	render() {
		if (project == null || project == '') {
			return (
				<Fragment>
					<Main />
				</Fragment>
			)
		} else {
			return (
				<Fragment>
					<Project project={project} />
				</Fragment>
			)
		}
	}
}

render(<QuantrDocs />, document.getElementById('app'));
